import { StrictMode, Suspense } from 'react'
import { createRoot } from 'react-dom/client'
import './index.css'
import App from './App.tsx'
import { TemplateProvider } from './contexts/template-context.tsx'
import { Provider } from 'react-redux'
import { persistor, store } from './redux/store.ts'
import { PersistGate } from 'redux-persist/integration/react'
import { ThemeProvider } from './contexts/theme-context.tsx'

createRoot(document.getElementById('root')!).render(
  <StrictMode>
    <Suspense fallback={<div>Loading...</div>}>
      <Provider store={store}>
        <PersistGate loading={null} persistor={persistor}>
          <TemplateProvider>
            <ThemeProvider>
              <div className="min-h-screen ">
                <App />
              </div>
            </ThemeProvider>
          </TemplateProvider>
        </PersistGate>
      </Provider>
    </Suspense>
  </StrictMode>,
)
